import { CelledEditor } from './CelledEditor';
import { withFirestore } from './withFirestore';

export default withFirestore(CelledEditor);
